export default __webpack_public_path__ + "static/media/animate-pizza-red.295d1058.gif";